/**
 * MCP (Model Context Protocol) アクセストークンの共有型 (docs/13 / 新規 docs MCP連携仕様)。
 *
 * 地区スコープの MCP サーバーへ「使い慣れた AI チャット (Claude / ChatGPT / Gemini)」から
 * ベアラートークンでアクセスするための、発行 / 一覧 / 失効 callable の I/O 契約と一覧行 (Summary)。
 *
 * 設計方針:
 *   - raw token は **発行時に1回だけ** 戻り値で返し、Firestore には sha256 ハッシュのみ保存する
 *     (読出漏洩しても再利用不可)。`/mcpTokens/{tokenId=sha256(raw)}` は firestore.rules で
 *     client 完全 deny (Admin SDK / Functions 専用)。詳細は functions/src/mcp/* と docs/13。
 *   - 有効期限は最大 365 日 (`MCP_TOKEN_MAX_EXPIRY_DAYS`)。発行後も `updateMcpTokenExpiry` で
 *     「今日から N 日」に入れ直せる (延長・短縮とも可、失効済みは不可)。master = 任意地区、地区管理者 = 自地区のみ
 *     を scope に指定でき、callable + サーバー双方で scope を強制する。
 *
 * 本ファイルは型のみ (apps / functions 双方が単一の真実源として import する)。Firestore doc の
 * server 内部表現 (Timestamp 付き) は functions/src/mcp 側に置く。ここでは wire 表現 (ISO8601) のみ。
 */
/** 有効期限の下限 (日)。 */
export const MCP_TOKEN_MIN_EXPIRY_DAYS = 1;
/** 有効期限の上限 (日)。当初「最大30日」→ 2026-10-06 オーナー指示で約1年に拡大。 */
export const MCP_TOKEN_MAX_EXPIRY_DAYS = 365;
/** 有効期限の既定 (日、未指定 / 不正値のとき)。 */
export const MCP_TOKEN_DEFAULT_EXPIRY_DAYS = 7;
/** 管理画面の期限プリセット (日)。 */
export const MCP_TOKEN_EXPIRY_PRESET_DAYS = [1, 3, 7, 14, 30, 60, 90, 180, 365];
//# sourceMappingURL=mcpToken.js.map